export default {
  BT_HDP: "ပေါက်ကြေး",
  BT_OU: "ဂိုးပေါ် / ဂိုးအောက်",
  BT_ML: "Moneyline",
  BT_1X2: "အနိုင်အရှုံးသရေ",
  BT_1X2HDP: "၃မျိုးပေါက်‌ကြေး",
  BT_CS: "ဂိုးခန့်မှန်း",
  BT_OE: "မ/စုံ",
  BT_DC: "နှစ်ထပ်အခွင့်အရေး",
  BT_HTFT: "ပထမပိုင်း / ပွဲချိန်ပြည့်",
  BT_FGLG: "ပထမဂိုး / နောက်ဆုံးဂိုး",
  BT_TG: "ဂိုးအရေအတွက်",
  BT_OR: "ဖလားခန့်မှန်း",
  BT_ORZ: "ဖလားခန့်မှန်း",

  BT_ANB: "အ‌ဝေးကွင်းလောင်း၍မရပါ",
  BT_BS: "နှစ်သင်း ၊ တစ်သင်း ၊ နှစ်သင်းလုံးဂိုးမသွင်းပါ",
  BT_CL: "ပေးဂိုးမရှိ",
  BT_DNB: "သရေလောင်း၍မရပါ",
  BT_DNBH: "ပထမပိုင်း သရေလောင်း၍မရပါ",
  BT_HNB: "အိမ်ကွင်းလောင်း၍မရပါ",
  BT_TWTN: "ပေးဂိုးမရှိပဲ အနိုင်ရရှိသူ",

  BT_HDPF: "ပေါက်ကြေး",
  BT_OUF: "ဂိုးပေါ် / ဂိုးအောက်",
  BT_MLF: "FT. Moneyline | FT. ML",
  BT_1X2F: "အနိုင်အရှုံးသရေ",
  BT_1X2HDPF: "၃မျိုးပေါက်‌ကြေး",
  BT_CSF: "ဂိုးခန့်မှန်း",
  BT_OEF: "မ/စုံ",
  BT_DCF: "နှစ်ထပ်အခွင့်အရေး",
  BT_FGLGF: "ပထမဂိုး / နောက်ဆုံးဂိုး",
  BT_TGF: "ဂိုးအရေအတွက်",

  BT_HDPH: "ပထမပိုင်းပေါက်ကြေး",
  BT_OUH: "ပထမပိုင်း ဂိုး‌ပေါင်း",
  BT_MLH: "ပထမပိုင်းအနိုင်",
  BT_1X2H: "ပထမပိုင်း အနိုင် ၊ အရှုံး ၊ သရေ",
  BT_1X2HDPH: "ပထမပိုင်း အနိုင် ၊ အရှုံး ၊ သရေ",
  BT_CSH: "ပထမပိုင်း ဂိုးခန့်မှန်း",
  BT_OEH: "ပထမပိုင်း မ/စုံ",
  BT_DCH: "ပထမပိုင်း နှစ်ထပ်အခွင့်အရေး",
  BT_FGLGH: "ပထမပိုင်း ပထမဂိုး / နောက်ဆုံးဂိုး",
  BT_TGH: "ပထမပိုင်း ဂိုးအရေအတွက်",
  BT_O: "ဂိုးပေါ်",
  BT_U: "ဂိုးအောက်",
  BT_ODD: "မ",
  BT_EVEN: "စုံ",

  BT_HDPOU: "‌ပေါက်ကြေး & ဂိုးပေါင်း",
  BT_PARLAY: "မောင်းကစားနည်း",
  BT_FT: "ပွဲချိန်ပြည့်",
  BT_1H: "ပထမပိုင်း. ",
  BT_2H: "ဒုတိယပိုင်း. ",

  BT_FG: "ပထမသွင်းဂိုး",
  BT_LG: "နောက်ဆုံးသွင်းဂိုး",
  BT_HFG: "ပထမသွင်းဂိုး (အိမ်ရှင်)",
  BT_AFG: "ပထမသွင်းဂိုး (အ‌ဝေး)",
  BT_HLG: "နောက်ဆုံးသွင်းဂိုး (အိမ်ရှင်)",
  BT_ALG: "နောက်ဆုံးသွင်းဂိုး (အဝေး)",
  BT_NG: "ဂိုးမသွင်း",
  BT_HY: "အိမ်ရှင် Yes",
  BT_HN: "အိမ်ရှင် No",
  BT_AY: "အဝေး Yes",
  BT_AN: "အဝေး No",
  BT_H: "အိမ်ရှင်",
  BT_A: "အဝေး",
  BT_D: "သရေ",
  BT_HD_DC: "အိမ်ရှင် & သရေ",
  BT_HA_DC: "အိမ်ရှင် & အဝေး",
  BT_DA_DC: "အဝေး & သရေ",
  BT_HH: "အိမ်ရှင် ၊ အိမ်ရှင်",
  BT_HD: "အိမ်ရှင် ၊ သရေ",
  BT_HA: "အိမ်ရှင် ၊ အဝေး",
  BT_DH: "သရေ ၊ အိမ်ရှင် ",
  BT_DD: "သရေ ၊ သရေ",
  BT_DA: "သရေ ၊ အဝေး",
  BT_AH: "အ‌ဝေး ၊ အိမ်ရှင် ",
  BT_AD: "အဝေး ၊ သရေ",
  BT_AA: "အဝေး ၊ အဝေး ",

  BT_Y: "Yes",
  BT_N: "No",

  BT_LIVE: "တိုက်ရိုက်",
  BT_HT: "ပထမပိုင်း ",
  BT_DELAYED: "နောက်ကျနေသည်",
  BT_PEN: "ပင်နယ်တီ",

  BT_FT1: "ပွဲချိန်ပြည့် 1 ",
  BT_FT2: "ပွဲချိန်ပြည့် 2",
  BT_FTX: "ပွဲချိန်ပြည့် x",
  BT_HT1: "HT.1",
  BT_HT2: "HT.2",
  BT_HTX: "HT.X",

  BT_BOTH: "နှစ်ဖက်စလုံး",
  BT_ONE: "တစ်",

  BS_HDP: "ပွဲချိန်ပြည့်ပေါက်ကြေး",
  BS_HDPH: "ပထမပိုင်း ပေါက်ကြေး",
  BS_OU: "ပွဲချိန်ပြည့် ဂိုးပေါင်း",
  BS_OUH: "ပထမပိုင်း ဂိုးပေါင်း",
  BS_OE: "ပွဲချိန်ပြည့် မ/စုံ",
  BS_OEH: "ပထမပိုင်း မ/စုံ",
  BS_1X2: "ပွဲချိန်ပြည့် 1x2",
  BS_1X2H: "ပထမပိုင်း 1x2",
  BS_ML: "ပွဲချိန်ပြည့် Moneyline",
  BS_MLH: "ပထမပိုင်း Moneyline",
  BS_1X2HDP: "ပွဲချိန်ပြည့် ၃ မျိုးပေါက်‌ကြေး",
  BS_1X2HDPH: "ပထမပိုင်း ၃ မျိုးပေါက်ကြေး",
  BS_CS: "ပွဲချိန်ပြည့် ဂိုးခန့်မှန်း",
  BS_CSH: "ပထမပိုင်း ဂိုးခန့်မှန်း",
  BS_DC: "ပွဲချိန်ပြည့် နှစ်ထပ်အခွင့်အရေး",
  BS_DCH: "ပထမပိုင်း နှစ်ထပ်အခွင့်အရေး",
  BS_FGLG: "ပွဲချိန်ပြည့် ပထမဂိုး / နောက်ဆုံးဂိုး",
  BS_FGLGH: "ပထမပိုင်း ပထမဂိုး / နောက်ဆုံးဂိုး",
  BS_TG: "ပွဲချိန်ပြည့် ဂိုးအရေအတွက်",
  BS_TGH: "ပထမပိုင်း ဂိုးအရေအတွက်",
  BS_ANB: "အဝေးကွင်း လောင်း၍မရပါ",
  BS_HTFT: "ပထမပိုင်း / ပွဲချိန်ပြည့်",
  BS_BS: "နှစ်သင်း ၊ တစ်သင်း ၊ နှစ်သင်းလုံးဂိုးမသွင်းပါ",
  BS_CL: "ပေးဂိုးမရှိ",
  BS_DNB: "သရေလောင်း၍မရပါ",
  BS_DNBH: "ပထမပိုင်း သရေလောင်း၍မရပါ",
  BS_HNB: "အိမ်ကွင်းလောင်း၍မရပါ",
  BS_TWTN: "ပေးဂိုးမရှိအနိုင်",
  BS_OR: "ဖလားခန့်မှန်း",
  BS_ORZ: "ဖလားခန့်မှန်း",
  
  LOT_BS: "အကြီး ၊ အသေး",
  LOT_BIG: "အကြီး",
  LOT_SMALL: "အသေး",
  LOT_OE: "မ/စုံ",
  LOT_ODD: "မ",
  LOT_EVEN: "စုံ",
  LOT_OU: "ဂိုးပေါ်/ဂိုးအောက်",
  LOT_OVER: "ဂိုးပေါ်",
  LOT_UNDER: "ဂိုးအောက်",
  LOT_FT: "FT",
  LOT_HT: "HT",

  BT_ALLBT: "အားလုံးအလောင်း",

  D_1: "တစ်လုံး",
  D_2: "နံပါတ် & ပြန်ပြောင်း",
  D_3: "ဘောက်စ်",
  D_4: "iဘောက်စ်",
  D_5: "နောက်ဆုံး ၃ လုံး",
  D_6: "နောက်ဆုံး ၂ လုံး",

  D_BIG: "ကြီး",
  D_SMALL: "သေး",
  D_AA: "AA",
  D_SA: "၃A",
  D_SB: "B",
  D_SC: "C",
  D_SD: "D",
  D_SE: "E",
  D_ABC: "၃C",

  LOT_1: "အိမ်",
  LOT_0: "ဧည့်",

  BT_KO: "K.O.",

  ODD_Home: "အိမ်",
  ODD_Away: "ဧည့်",
  ODD_Draw: "သရေ",
  ODD_Over: "အထက်",
  ODD_Under: "အောက်",
  ODD_Odd: "မီ",
  ODD_Even: "စုံ",

  GH_1X2: "အနိုင်",
  GH_1X20: "အနိုင်",
  GH_1X2HDP: "နေရာ/ပြခန်း",
  GH_1X2HDP2: "နေရာ",
  GH_1X2HDP4: "ပြခန်း",
  GH_OVER: "အထက် (၄, ၅, ၆)",
  GH_UNDER: "အောက် (၁, ၂, ၃)",
  GH_ODD: "မီ (၁, ၃, ၅)",
  GH_EVEN: "စုံ (၂, ၄, ၆)",
  GH_OU1: "အထက် (၄, ၅, ၆)",
  GH_OU2: "အောက် (၁, ၂, ၃)",
  GH_OE1: "မီ (၁, ၃, ၅)",
  GH_OE2: "စုံ (၂, ၄, ၆)",

  GX_1X2: "အနိုင်",
  GX_1X20: "အနိုင်",
  GX_1X2HDP: "နေရာ/ပြခန်း",
  GX_1X2HDP2: "နေရာ",
  GX_1X2HDP4: "ပြခန်း",
  GX_OVER: "အထက် (၇-၁၂)",
  GX_UNDER: "အောက် (၁-၆)",
  GX_ODD: "မီ (၁, ၃, ၅, ၇, ၉, ၁၁)",
  GX_EVEN: "စုံ (၂, ၄, ၆, ၈, ၁၀, ၁၂)",
  GX_OU1: "အထက် (၇-၁၂)",
  GX_OU2: "အောက် (၁-၆)",
  GX_OE1: "မီ (၁, ၃, ၅, ၇, ၉, ၁၁)",
  GX_OE2: "စုံ (၂, ၄, ၆, ၈, ၁၀, ၁၂)",

  GC_OU: "O/U",
  GC_OE: "O/E",
  GC_OVER: "အထက် (၃, ၄, ၅)",
  GC_UNDER: "အောက် (၀, ၁, ၂)",
  GC_ODD: "မီ (၁, ၃, ၅)",
  GC_EVEN: "စုံ (၀, ၂, ၄)",
  GC_5_0: "၅-၀",
  GC_4_1: "၄-၁",
  GC_3_2: "၃-၂",
  GC_0_5: "၀-၅",
  GC_1_4: "၁-၄",
  GC_2_3: "၂-၃",
  GC_ML0: "ပထမ ဗလ",
  GC_1X20: "အနိုင်",
  GC_ML: "ပထမ ဗလ",
  GC_1X2: "အနိုင်",
  GC_OU1: "အထက် (၃, ၄, ၅)",
  GC_OU2: "အောက် (၀, ၁, ၂)",
  GC_OE1: "မီ (၁, ၃, ၅)",
  GC_OE2: "စုံ (၀, ၂, ၄)",

  GR_RED: "အနီ (1)",
  GR_YELLOW: "အဝါ (2)",
  GR_BLUE: "အပြာ (3)",
  GR_GREEN: "အစိမ်း (4)",
  GR_OVER: "အထက် (၃, ၄)",
  GR_UNDER: "အောက် (၁, ၂)",
  GR_ODD: "မီ (၁, ၃)",
  GR_EVEN: "စုံ (၂, ၄)",
  GR_SINGLE: "တစ်ခု",
  GR_PAIR: "အတွဲ",
  GR_TRIPS: "သုံးခု",
  GR_ADVANCED: "အောင်မြင်",
  GR_ELIMINATED: "ဖယ်ရှား",
  GR_HIT1: "HIT 1",
  GR_HIT2: "HIT 2",
  GR_PERFECT: "ပြီးပြည့်စုံ",
  GR_MLHOME: "အောင်မြင်",
  GR_MLAWAY: "ဖယ်ရှား",
  GR_1X2FT1: "တစ်ခု",
  GR_1X2FTX: "အတွဲ",
  GR_1X2FT2: "သုံးခု",
  GR_ML1: "အောင်မြင်",
  GR_ML2: "ဖယ်ရှား",
  GR_1X21: "တစ်ခု",
  GR_1X22: "သုံးခု",
  GR_1X23: "အတွဲ",
  GR_OU1: "အထက် (၃, ၄)",
  GR_OU2: "အောက် (၁, ၂)",
  GR_OE1: "မီ (၁, ၃)",
  GR_OE2: "စုံ (၂, ၄)",

  ROOM_A: "ဖွင့်ပါ",
  ROOM_0: "လည်ပတ်နေ",
  ROOM_1: "ပိတ်ထားသည်",
  ROOM_2: "ဖျက်သိမ်းသည်",
  ROOM_3: "ပြီးဆုံးသည်",
  ROOM_4: "အလောင်းပစ်ရပ်တန်",
  ROOM_10: "အားလုံး",

  ROOM_T0: "အားလုံး",
  ROOM_T1: "ပြင်ပကွက်",
  ROOM_T2: "ပုဂ္ဂိုလ်ရေး ကွက်",
  ROOM_T3: "ကစားပြီး အမိန့်",

  joinRoom1: "ပြင်ပကွက်လေးကို အသုံးပြုပါ",
  joinRoom2: "ပုဂ္ဂိုလ်ရေး ကွက်ကို အသုံးပြုပါ",
  joinRoom3: "ကစားပြီး အမိန့် ကွက်ကို အသုံးပြုပါ",
  createRoom1: "ပြင်ပကွက်ကို ဖန်တီးပါ",
  createRoom2: "ပုဂ္ဂိုလ်ရေး ကွက်ကို ဖန်တီးပါ",
  createRoom3: "ကစားပြီး အမိန့် ကွက်ကို ဖန်တီးပါ",
  Champion: "အနိုင်ရသူ",
  FirstRunnerUp: "ပထမ ကောင်းမွန်သူ",
  SecondRunnerUp: "ဒုတိယ ကောင်းမွန်သူ",

  BT_OEHM: "အိမ် Odd/Even",
  BT_OEHMH: "HT. အိမ် Odd/Even",
  BT_OEAW: "ပြင်ပ Odd/Even",
  BT_OEAWH: "HT. ပြင်ပ Odd/Even",

  BS_OEHM: "FT. အိမ် Odd/Even",
  BS_OEHMH: "HT. အိမ် Odd/Even",
  BS_OEAW: "FT. ပြင်ပ Odd/Even",
  BS_OEAWH: "HT. ပြင်ပ Odd/Even",

  MB_OVER: "အထက် (၄, ၅, ၆)",
  MB_UNDER: "အောက် (၁, ၂, ၃)",
  MB_ODD: "မီ (၁, ၃, ၅)",
  MB_EVEN: "စုံ (၂, ၄, ၆)",

  BS_1X2OU: "1X2 + OU",
  BT_1X2OU: "1X2 + OU",
  BT_1O: "1O",
  BT_1U: "1U",
  BT_2O: "2O",
  BT_2U: "2U",
  BT_XO: "XO",
  BT_XU: "XU",

  BS_DCOU: "Double Chance + OU",
  BT_DCOU: "Double Chance + OU",
  BT_HDO: "HDO",
  BT_HDU: "HDU",
  BT_HAO: "HAO",
  BT_HAU: "HAU",
  BT_DAO: "DAO",
  BT_DAU: "DAU",

  BS_OUOE: "OU + OE",
  BT_OUOE: "OU + OE",
  BK_OO: "OO",
  BK_OE: "OE",
  BK_UO: "UO",
  BK_UE: "UE",

  BS_HTFTOE: "HT/FT + OE",
  BT_HTFTOE: "HT/FT + OE",
  BK_EO: "EO",
  BK_EE: "EE",

  BS_WM: "အနိုင်အလွန်",
  BT_WM: "အနိုင်အလွန်",
  BK_H1: "အိမ် ၁",
  BK_H2: "အိမ် ၂",
  BK_H3Up: "အိမ် ၃+",
  BK_A1: "ပြင်ပ ၁",
  BK_A2: "ပြင်ပ ၂",
  BK_A3Up: "ပြင်ပ ၃+",
  BK_D: "ဆက်စပ်တင် (Excl. 0-0)",
  BK_NG: "ဂိုးမရှိ",

  BS_ETG: "တိကျသောစုစုပေါင်းဂိုး",
  BT_ETG: "တိကျသောစုစုပေါင်းဂိုး",
  BS_EHTG: "တိကျသောအိမ်စုစုပေါင်းဂိုး",
  BT_EHTG: "တိကျသောအိမ်စုစုပေါင်းဂိုး",
  BS_EATG: "တိကျသောပြင်ပစုစုပေါင်းဂိုး",
  BT_EATG: "တိကျသောပြင်ပစုစုပေါင်းဂိုး",
  BS_ETGH: "HT. တိကျသောစုစုပေါင်းဂိုး",
  BT_ETGH: "HT. တိကျသောစုစုပေါင်းဂိုး",
  BS_EHTGH: "HT. တိကျသောအိမ်စုစုပေါင်းဂိုး",
  BT_EHTGH: "HT. တိကျသောအိမ်စုစုပေါင်းဂိုး",
  BS_EATGH: "HT. တိကျသောပြင်ပစုစုပေါင်းဂိုး",
  BT_EATGH: "HT. တိကျသောပြင်ပစုစုပေါင်းဂိုး",
  BT_0: "၀",
  BT_1: "၁",
  BT_2: "၂",
  BT_3: "၃",
  BT_4: "၄",
  BT_5: "၅",
  BT_6Up: "၆+",
  BT_3Up: "၃+",

  BT_CSHTFT: "HT/FT ဂိုးရလဒ်",
  BS_CSHTFT: "HT/FT ဂိုးရလဒ်",
  BT_ETGHTFT: "HT/FT ဂိုးပေါင်း",
  BS_ETGHTFT: "HT/FT ဂိုးပေါင်း",

  CF_CS_2_1: "၂-၁ အချီ ကစားပွဲ",
  CF_CS_2_0: "၂-၀ အချီ ကစားပွဲ",
  CF_CS_0_2: "၀-၂ အချီ ကစားပွဲ",
  CF_CS_1_2: "၁-၂ အချီ ကစားပွဲ",
  CF_R_1_W: "ပထမအပတ်အနိုင်ယူသူ",
  CF_R_2_W: "ဒုတိယအပတ်အနိုင်ယူသူ",
  CF_R_3_W: "တတိယအပတ်အနိုင်ယူသူ",
  CF_MLHOME: "အိမ်အသင်းအနိုင်",
  CF_MLAWAY: "ဧည့်အဖွဲ့အနိုင်",
  CF_EVEN: "နှစ်ပတ်ယှဉ်ပြိုင်",
  CF_ODD: "သုံးပတ်ယှဉ်ပြိုင်",
  CF_ML1: "အိမ်အသင်းအနိုင်",
  CF_ML2: "ဧည့်အဖွဲ့အနိုင်",
  CF_ML: "တစ်ဦးတည်းအနိုင်",
  CF_CS: "မှန်ကန်သောအမှတ်အသား",
  CF_OE: "နှစ်ဆ/တစ်ဆ",
  CF_0: "ပြန်တန်း",
  CF_1: "အိမ်",
  CF_2: "ဧည့်",
  CF_OE1: "နှစ်ဆ",
  CF_OE2: "တစ်ဆ",
    
  EF8_R1_1STBOOM: "ပထမအချီ ပထမ BOOM",
  EF8_R2_1STBOOM: "ဒုတိယအချီ ပထမ BOOM",
  EF8_R3_1STBOOM: "တတိယအချီ ပထမ BOOM",
  EF8_0: "-",
  EF8_1: "အိမ်",
  EF8_2: "ဧည့်",

};